import React from "react";
import DaumPostcode from "react-daum-postcode";

interface AddressSearchModalProps {
  isOpen: boolean;
  onComplete: (data: { address: string; zonecode: string }) => void;
  onClose: () => void;
}

/**
 * 주소 검색 모달 컴포넌트
 * Daum Postcode API를 사용하여 주소 검색 기능 제공
 */
export function AddressSearchModal({
  isOpen,
  onComplete,
  onClose,
}: AddressSearchModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl max-h-[90vh] md:max-h-[85vh] overflow-hidden">
        {/* 헤더 */}
        <div className="flex justify-between items-center p-3 md:p-4 border-b">
          <h2 className="text-base md:text-lg font-semibold">주소 검색</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-2xl"
          >
            ×
          </button>
        </div>

        {/* 주소 검색 폼 */}
        <div
          className="overflow-y-auto"
          style={{ maxHeight: "calc(90vh - 60px)" }}
        >
          <DaumPostcode
            onComplete={(data) => {
              onComplete({
                address: data.address,
                zonecode: data.zonecode,
              });
              onClose();
            }}
            autoClose={false}
          />
        </div>
      </div>
    </div>
  );
}
